import React from "react";
import "./ruko.scss";
import Rukoimage from "../../media/ruko.png";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import galeria from "./galeria";
import grandia from "./grandia";

const ruko = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const rukowa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(ruko)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const kavlingwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(kavling)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const galeriawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(kavling)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const grandiawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(kavling)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div id="ruko" className="container-ruko">
      <div className="judul-ruko">COMMERCIAL AREA & KAVLING</div>

      <div className="container-card1">
        <div className="kartu">
          <Slider {...settings}>
            {galeria.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="maple"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Galleria Shophouse</div>
            </div>
            <div className="cicilan">
              <div className="angka">16</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />

          <div className="containerwhatsapp">
            <button onClick={galeriawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {grandia.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="maple"
                />
              </div>
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Grandia Avenue</div>
            </div>
            <div className="cicilan">
              <div className="angka">11</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="containerwhatsapp">
            <button onClick={grandiawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      {/* <div className="container-wa">
        <button onClick={rukowa} className="whatsapp">
          <div className="wa-ruko">
            <div className="icon">
              <FontAwesomeIcon color="#273444" size="3x" icon={faWhatsapp} />
            </div>
            <div className="main-title">
              <div className="title1">Ruko Northwest Boulevard</div>
              <div className="title2">
                <p>3 LANTAI, LUAS &gt;100m</p>
              </div>
            </div>
          </div>
        </button>
        <button onClick={kavlingwa} className="whatsapp">
          <div className="wa-kavling">
            <div className="icon">
              <FontAwesomeIcon color="#273444" size="3x" icon={faWhatsapp} />
            </div>
            <div className="main-title">
              <div className="title1">Northwest Park Kavling</div>
              <div className="title2">
                <p>LUAS 120m-200m</p>
              </div>
            </div>
          </div>
        </button>
      </div> */}
    </div>
  );
};

export default ruko;
